import type { Widget } from 'types/dashboards';
import { createDialogWithIdStore } from '../createDialogWithIdStore';

export const useCopyWidgetDialog = createDialogWithIdStore<Widget>();
